<router-outlet />
<app-online-status
    [onlineStatusMessage]="connectionStatusMessage"
    [onlineStatus]="connectionStatus">
</app-online-status>